export default __webpack_public_path__ + "static/media/wh_0.ebf76644.mp3";